export default __webpack_public_path__ + "static/media/google-play-store.61ac97c7.svg";